import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTestimonialSliderSmall = {
  factory: EElement({
    id: '92aa4745-feea-be1c-8a3f-397fe9374636',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('837fbfb1-1106-0074-1c84-d08384f1d243')]),
      children: EList([
        EElement({
          id: '28ff7a18-cf79-a846-62cd-0c1628f8890e',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '28ff7a18-cf79-a846-62cd-0c1628f8890f',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4'),
                  ]),
                  children: EList([
                    EElement({
                      id: '28ff7a18-cf79-a846-62cd-0c1628f88910',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Testimonial section title'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'f3bd8af3-0f12-2981-aaec-b656ae00b3a2',
                type: qualify(
                  Plugins.name('Basic'),
                  Component.name('Paragraph')
                ),
                data: ERecord({
                  styleBlockIds: EList([
                    EText('e8e462ae-eca2-3d8e-55fa-0d15b916d1ba'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'f3bd8af3-0f12-2981-aaec-b656ae00b3a3',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText(
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem.'
                      ),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '28ff7a18-cf79-a846-62cd-0c1628f88914',
                type: qualify(
                  Plugins.name('Slider'),
                  Component.name('SliderWrapper')
                ),
                data: ERecord({
                  slider: ERecord({
                    navSpacing: ENumber(3),
                    navShadow: EBoolean(false),
                    autoplay: EBoolean(false),
                    delay: ENumber(4000),
                    iconArrows: EBoolean(true),
                    animation: EEnum('slide'),
                    navNumbers: EBoolean(false),
                    easing: EEnum('ease'),
                    navRound: EBoolean(true),
                    hideArrows: EBoolean(true),
                    disableSwipe: EBoolean(false),
                    duration: ENumber(500),
                    infinite: EBoolean(true),
                    autoMax: ENumber(0),
                    navInvert: EBoolean(false),
                    type: EText('wrapper'),
                  }),
                  styleBlockIds: EList([
                    EText('a898d472-8dba-1253-6aa8-030bc97ec4cc'),
                  ]),
                  children: EList([
                    EElement({
                      id: '28ff7a18-cf79-a846-62cd-0c1628f88915',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderMask')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          type: EText('slides'),
                        }),
                        children: EList([
                          EElement({
                            id: '28ff7a18-cf79-a846-62cd-0c1628f88916',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('slide'),
                              }),
                              styleBlockIds: EList([
                                EText('3b26f7b2-dc72-33c9-180e-5e88677345bf'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '42b136cc-0378-66f9-c958-ae8a99ec221e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '47783e21-e6b8-f6d9-76f0-3fd8f798b1f6'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '7a4021fb-6577-cc87-91e1-d92df761e6ab',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Paragraph')
                                        ),
                                        data: ERecord({
                                          children: EList([
                                            EElement({
                                              id: '7a4021fb-6577-cc87-91e1-d92df761e6ac',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros.'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '4f2f847a-6fb0-7b60-f7d9-e1750d3aa5ee',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'd35b7baf-eb5f-e236-93b9-a59144a7a653'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '309136a1-983d-79ff-6e25-f12249af26a1',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.placeholderImageHills
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796bb8d485104da7de23c9"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'e7764fad-f719-a84a-d54b-5cf66da6fd6c',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: 'e7764fad-f719-a84a-d54b-5cf66da6fd6d',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Heading')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('h3'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8b1f5cc0-6857-f343-fdba-6e9beefa44a0'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: 'e7764fad-f719-a84a-d54b-5cf66da6fd6e',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Author Name'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: 'e7764fad-f719-a84a-d54b-5cf66da6fd6f',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: 'e7764fad-f719-a84a-d54b-5cf66da6fd70',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'CEO / Company'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'c3f108c6-beb9-068a-b8de-02349bd7d532',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5ce12346-8028-2eec-5816-93cf6d710718'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'ec8055fe-84f3-03c6-d57e-500b67268433',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.doubleQuoteRoundLight
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_inherit'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"62796bb8d485104da7de23dc"}'
                                                        ),
                                                      }),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '28ff7a18-cf79-a846-62cd-0c1628f88917',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('slide'),
                              }),
                              styleBlockIds: EList([
                                EText('3b26f7b2-dc72-33c9-180e-5e88677345bf'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '21e57e47-687f-ba5a-b71d-541562141ab5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '47783e21-e6b8-f6d9-76f0-3fd8f798b1f6'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '21e57e47-687f-ba5a-b71d-541562141ab7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Paragraph')
                                        ),
                                        data: ERecord({
                                          children: EList([
                                            EElement({
                                              id: '21e57e47-687f-ba5a-b71d-541562141ab8',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros.'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '21e57e47-687f-ba5a-b71d-541562141ab9',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'd35b7baf-eb5f-e236-93b9-a59144a7a653'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '21e57e47-687f-ba5a-b71d-541562141aba',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.placeholderImageHills
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796bb8d485104da7de23c9"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '21e57e47-687f-ba5a-b71d-541562141abb',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: '21e57e47-687f-ba5a-b71d-541562141abc',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Heading')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('h3'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8b1f5cc0-6857-f343-fdba-6e9beefa44a0'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '21e57e47-687f-ba5a-b71d-541562141abd',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Author Name'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '21e57e47-687f-ba5a-b71d-541562141abe',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '21e57e47-687f-ba5a-b71d-541562141abf',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'CEO / Company'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '21e57e47-687f-ba5a-b71d-541562141ac0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5ce12346-8028-2eec-5816-93cf6d710718'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '21e57e47-687f-ba5a-b71d-541562141ac1',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.doubleQuoteRoundLight
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_decorative'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"62796bb8d485104da7de23dc"}'
                                                        ),
                                                      }),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '28ff7a18-cf79-a846-62cd-0c1628f88918',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              styleBlockIds: EList([
                                EText('3b26f7b2-dc72-33c9-180e-5e88677345bf'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '9baf70db-cd42-ad04-369f-e3fd742c59c4',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '47783e21-e6b8-f6d9-76f0-3fd8f798b1f6'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '9baf70db-cd42-ad04-369f-e3fd742c59c6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Paragraph')
                                        ),
                                        data: ERecord({
                                          children: EList([
                                            EElement({
                                              id: '9baf70db-cd42-ad04-369f-e3fd742c59c7',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '9baf70db-cd42-ad04-369f-e3fd742c59c8',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'd35b7baf-eb5f-e236-93b9-a59144a7a653'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '9baf70db-cd42-ad04-369f-e3fd742c59c9',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.placeholderImageHills
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796bb8d485104da7de23c9"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '9baf70db-cd42-ad04-369f-e3fd742c59ca',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: '9baf70db-cd42-ad04-369f-e3fd742c59cb',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Heading')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('h3'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8b1f5cc0-6857-f343-fdba-6e9beefa44a0'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '9baf70db-cd42-ad04-369f-e3fd742c59cc',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Profile name'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '9baf70db-cd42-ad04-369f-e3fd742c59cd',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '9baf70db-cd42-ad04-369f-e3fd742c59ce',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'CEO / Creative IT'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '9baf70db-cd42-ad04-369f-e3fd742c59cf',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5ce12346-8028-2eec-5816-93cf6d710718'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '9baf70db-cd42-ad04-369f-e3fd742c59d0',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.doubleQuoteRoundLight
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_inherit'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"62796bb8d485104da7de23dc"}'
                                                        ),
                                                      }),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '28ff7a18-cf79-a846-62cd-0c1628f88919',
                            type: qualify(
                              Plugins.name('Slider'),
                              Component.name('SliderSlide')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              slider: ERecord({
                                type: EText('Slider'),
                              }),
                              styleBlockIds: EList([
                                EText('3b26f7b2-dc72-33c9-180e-5e88677345bf'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd0',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '47783e21-e6b8-f6d9-76f0-3fd8f798b1f6'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd2',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Paragraph')
                                        ),
                                        data: ERecord({
                                          children: EList([
                                            EElement({
                                              id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd3',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd4',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('div'),
                                          text: EBoolean(false),
                                          styleBlockIds: EList([
                                            EText(
                                              'd35b7baf-eb5f-e236-93b9-a59144a7a653'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd5',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.placeholderImageHills
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"62796bb8d485104da7de23c9"}'
                                                  ),
                                                }),
                                                styleBlockIds: EList([
                                                  EText(
                                                    'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                                  ),
                                                ]),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                            EElement({
                                              id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd6',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd7',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Heading')
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('h3'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8b1f5cc0-6857-f343-fdba-6e9beefa44a0'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd8',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Profile name'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                  EElement({
                                                    id: '3b61e434-9a5b-6721-a3b9-4e3264aeadd9',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Block')
                                                    ),
                                                    data: ERecord({
                                                      text: EBoolean(true),
                                                      tag: EEnum('div'),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '8af53af0-f60d-5b01-c583-17ee60d4d532'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '3b61e434-9a5b-6721-a3b9-4e3264aeadda',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'CEO / Creative IT'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '3b61e434-9a5b-6721-a3b9-4e3264aeaddb',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '5ce12346-8028-2eec-5816-93cf6d710718'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '3b61e434-9a5b-6721-a3b9-4e3264aeaddc',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Image')
                                                    ),
                                                    data: ERecord({
                                                      attr: ERecord({
                                                        src: EText(
                                                          images.doubleQuoteRoundLight
                                                        ),
                                                        loading: EEnum('lazy'),
                                                        width: EText('auto'),
                                                        height: EText('auto'),
                                                        alt: EText(
                                                          '__wf_reserved_inherit'
                                                        ),
                                                      }),
                                                      img: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Asset'),
                                                          typeName('Image')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"id":"62796bb8d485104da7de23dc"}'
                                                        ),
                                                      }),
                                                      temp: ERecord({
                                                        img: ERecord({
                                                          src: EText(''),
                                                        }),
                                                      }),
                                                      srcsetDisabled:
                                                        EBoolean(false),
                                                      sizes: EList([]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '28ff7a18-cf79-a846-62cd-0c1628f8891a',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderArrow')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          dir: EText('left'),
                        }),
                        styleBlockIds: EList([
                          EText('284b83a3-6f8d-b4e7-f3c6-d2fc0b8b28a6'),
                        ]),
                        children: EList([
                          EElement({
                            id: '6af98ec2-cf4b-bd87-790b-46099d7ae062',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('f0f6a58d-b394-7f63-4fc5-39a39a70be3f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '40f50499-ed88-6fbb-a62a-2a3d11e4fc77',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.chevronCircleLeft),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62796bb8d485104da7de23d2"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'c2fd480d-3cb7-ef14-5a42-3351be3630c9'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '28ff7a18-cf79-a846-62cd-0c1628f8891c',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderArrow')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          dir: EText('right'),
                        }),
                        styleBlockIds: EList([
                          EText('17565a2d-1979-75e4-c86a-f5c4c6492696'),
                        ]),
                        children: EList([
                          EElement({
                            id: '98d74d6f-68e7-3a91-a1d9-956602ae954f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('f0f6a58d-b394-7f63-4fc5-39a39a70be3f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'ddc5e813-a194-419f-2f8d-2d8684ea7f67',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.chevronCircleRight),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62796bb8d485104da7de23bb"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'c2fd480d-3cb7-ef14-5a42-3351be3630c9'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '28ff7a18-cf79-a846-62cd-0c1628f8891e',
                      type: qualify(
                        Plugins.name('Slider'),
                        Component.name('SliderNav')
                      ),
                      data: ERecord({
                        slider: ERecord({
                          type: EText('nav'),
                        }),
                        styleBlockIds: EList([
                          EText('175263cc-aeaa-c7b3-1952-7bee760e0152'),
                        ]),
                        children: EList([]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '837fbfb1-1106-0074-1c84-d08384f1d243',
      type: 'class',
      name: 'Testimonial Slider Small',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4',
      type: 'class',
      name: 'Centered Heading',
      comb: '',
      styleLess: 'margin-bottom: 16px; text-align: center;',
      children: ['d857c47f-13ef-6c7e-7f97-30e5beebeba3'],
      variants: {tiny: {styleLess: 'margin-bottom: 24px;'}},
    },
    {
      _id: 'e8e462ae-eca2-3d8e-55fa-0d15b916d1ba',
      type: 'class',
      name: 'Centered Subheading',
      comb: '',
      styleLess:
        'max-width: 530px; margin-right: auto; margin-left: auto; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'a898d472-8dba-1253-6aa8-030bc97ec4cc',
      type: 'class',
      name: 'Testimonial Slider',
      comb: '',
      styleLess:
        'height: auto; max-width: 800px; margin-top: 50px; margin-right: auto; margin-left: auto; background-color: transparent;',
      children: [],
      variants: {},
    },
    {
      _id: '3b26f7b2-dc72-33c9-180e-5e88677345bf',
      type: 'class',
      name: 'Testimonial Slide Wrapper',
      comb: '',
      styleLess: 'max-width: 48%; margin-right: 4%;',
      children: [],
      variants: {
        tiny: {styleLess: 'max-width: 100%; margin-right: 0%;'},
        small: {styleLess: 'max-width: 100%; margin-right: 0%;'},
      },
    },
    {
      _id: '47783e21-e6b8-f6d9-76f0-3fd8f798b1f6',
      type: 'class',
      name: 'Testimonial Card',
      comb: '',
      styleLess:
        'display: flex; padding-top: 24px; padding-right: 24px; padding-bottom: 24px; padding-left: 24px; flex-direction: column; align-items: flex-start; background-color: hsla(0, 0.00%, 100.00%, 1.00);',
      children: [],
      variants: {
        small: {styleLess: 'margin-right: 10px; margin-left: 10px;'},
        tiny: {styleLess: 'margin-right: 10px; margin-left: 10px;'},
      },
    },
    {
      _id: 'd35b7baf-eb5f-e236-93b9-a59144a7a653',
      type: 'class',
      name: 'Testimonial Info',
      comb: '',
      styleLess:
        'display: flex; margin-top: 24px; align-items: center; align-self: stretch;',
      children: [],
      variants: {},
    },
    {
      _id: 'eee554db-e006-8dc8-ae3d-0f25db8d5e13',
      type: 'class',
      name: 'Testimonial Image',
      comb: '',
      styleLess:
        'width: 60px; height: 60px; margin-right: 16px; border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; object-fit: cover;',
      children: ['ef5c9902-3a40-6a1b-9c7a-521d48c5e000'],
      variants: {},
    },
    {
      _id: '8b1f5cc0-6857-f343-fdba-6e9beefa44a0',
      type: 'class',
      name: 'Testimonial Author',
      comb: '',
      styleLess: 'margin-bottom: 2px;',
      children: [],
      variants: {},
    },
    {
      _id: '8af53af0-f60d-5b01-c583-17ee60d4d532',
      type: 'class',
      name: 'Tagline',
      comb: '',
      styleLess: 'margin-bottom: 10px; font-size: 12px; line-height: 16px;',
      children: [],
      variants: {},
    },
    {
      _id: '5ce12346-8028-2eec-5816-93cf6d710718',
      type: 'class',
      name: 'Testimonial Icon Wrapper',
      comb: '',
      styleLess:
        'display: flex; justify-content: flex-end; flex-grow: 1; flex-shrink: 1; flex-basis: 0%;',
      children: [],
      variants: {},
    },
    {
      _id: '284b83a3-6f8d-b4e7-f3c6-d2fc0b8b28a6',
      type: 'class',
      name: 'Testimonial Slider Left',
      comb: '',
      styleLess:
        'left: -70px; display: flex; width: 40px; justify-content: center; align-items: center;',
      children: [],
      variants: {
        medium: {styleLess: 'left: -20px;'},
        tiny: {styleLess: 'left: -10px;'},
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px;',
        },
        small: {styleLess: 'left: -10px;'},
      },
    },
    {
      _id: 'f0f6a58d-b394-7f63-4fc5-39a39a70be3f',
      type: 'class',
      name: 'Arrow Wrapper',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: 'c2fd480d-3cb7-ef14-5a42-3351be3630c9',
      type: 'class',
      name: 'Slider Arrow Embed',
      comb: '',
      styleLess: 'color: #1a1b1f;',
      children: [],
      variants: {},
    },
    {
      _id: '17565a2d-1979-75e4-c86a-f5c4c6492696',
      type: 'class',
      name: 'Testimonial Slider Right',
      comb: '',
      styleLess:
        'right: -70px; display: flex; width: 40px; justify-content: center; align-items: center;',
      children: [],
      variants: {
        medium: {styleLess: 'right: -20px;'},
        tiny: {styleLess: 'right: -10px;'},
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px;',
        },
        small: {styleLess: 'right: -10px;'},
      },
    },
    {
      _id: '175263cc-aeaa-c7b3-1952-7bee760e0152',
      type: 'class',
      name: 'Testimonial Slide Nav',
      comb: '',
      styleLess: 'display: none;',
      children: [],
      variants: {},
    },
  ],
} as const;
